module.exports = __webpack_public_path__ + "static/skill-factory-eb7da35c1ff7cb5595945368a9b1aa30.svg";